module.exports = __webpack_public_path__ + "img/ex-mini-on.e97f1069.png";